import type { UniverseSearchModel } from '../UniverseCreationModel';
import type { ConcreteIndicator, EnumeratedReturnValue } from '@thinkalpha/platform-ws-client/contracts/dictionary.js';

/**
 * View-model–aware projection of `indicator.enumeratedReturnValues`. Backtest
 * skips entries lacking `backtestData` because the backtest engine can't map
 * them; the screener keeps every entry. Narrowing to the scalar value subset
 * `SetConditionModel` actually surfaces is the model's responsibility.
 */
export function indicatorEnumeratedValues(
    indicator: ConcreteIndicator,
    searchModel: UniverseSearchModel,
): EnumeratedReturnValue[] | undefined {
    const all = indicator.enumeratedReturnValues;
    if (all == null) return undefined;
    if (searchModel === 'screener') return [...all];
    return all.filter((entry) => entry.backtestData != null);
}
